import {makeAutoObservable} from 'mobx';

import {DocumentInResponse} from '@lexian/api/documents-api';

export class DocumentActionStore {
  public movingDocumentsParams?: DocumentInResponse[];

  public shareDocumentsParams?: DocumentInResponse[];

  public shareDocumentsViaMailTemplateParams?: DocumentInResponse[];

  public renameDocumentParam?: DocumentInResponse;

  public copyDocumentParam?: DocumentInResponse;

  public duplicateDocumentParam?: DocumentInResponse;

  public constructor() {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  public setMoveParams(documents: DocumentInResponse[]): void {
    this.movingDocumentsParams = documents;
  }

  public setShareParams(documents: DocumentInResponse[]): void {
    this.shareDocumentsParams = documents;
  }

  public setShareViaEmailTemplateParams(documents: DocumentInResponse[]): void {
    this.shareDocumentsViaMailTemplateParams = documents;
  }

  public setRenameDocumentParam(document: DocumentInResponse): void {
    this.renameDocumentParam = document;
  }

  public setCopyParam(document: DocumentInResponse): void {
    this.copyDocumentParam = document;
  }

  public setDuplicateParam(document: DocumentInResponse): void {
    this.duplicateDocumentParam = document;
  }

  public removeMovingParams(): void {
    this.movingDocumentsParams = undefined;
  }

  public removeShareParams(): void {
    this.shareDocumentsParams = undefined;
  }

  public removeShareViaEmailTemplateParams(): void {
    this.shareDocumentsViaMailTemplateParams = undefined;
  }

  public removeRenameDocumentParam(): void {
    this.renameDocumentParam = undefined;
  }

  public removeCopyParam(): void {
    this.copyDocumentParam = undefined;
  }

  public removeDuplicateParam(): void {
    this.duplicateDocumentParam = undefined;
  }
}
